import { KYMW1600Model } from '../kymw1600.model';
import { GetImageInfoModel } from '../vo/get-image-info.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 画像情報取得要求サービス
 *
 * @export GetImageInfoService
 * @class GetImageInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class ReplaceImageFileService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1300Model}
   * @memberof GetImageInfoService
   */
  private model: KYMW1600Model;

  /**
   * 処理に使用するVO
   *
   * @private
   * @type {Object}
   * @memberof GetImageInfoService
   */
  private vo: {
    imageId: string,				  // 画像ID
    tempPNGFileName: string,	// 一時PNGイメージファイル名
    tempEPSFileName: string,	// 一時EPSイメージファイル名
    tempJPGSFileName: string,	// 一時JPG(S)イメージファイル名
    tempJPGMFileName: string,	// 一時JPG(M)イメージファイル名
    tempJPGLFileName: string,	// 一時JPG(L)イメージファイル名
  };

  /**
   * 成功時に行う処理
   *
   * @private
   * @type {Function}
   * @memberof ReplaceImageFileService
   */
  private successFunction: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetImageInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ImageId: this.vo.imageId,
        TempPNGFileName: this.vo.tempPNGFileName,
        TempEPSFileName: this.vo.tempEPSFileName,
        TempJPGSFileName: this.vo.tempJPGSFileName,
        TempJPGMFileName: this.vo.tempJPGMFileName,
        TempJPGLFileName: this.vo.tempJPGLFileName
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetImageInfoService
   */
  execute(model: KYMW1600Model, vo: any, successFunction: Function): void {
    this.model = model;
    this.vo = vo;
    this.successFunction = successFunction;
    this.send('KYMW16ReplaceImageFile', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetImageInfoService
   */
  success(data: any): void {
    this.successFunction(data);
  }
}
